import {RestDataLoader} from "../dashboard/widgets/unilever/RestDataLoader";
import {VeboxModels} from "../types/veboxModels";
import {
    ChangeCredentialsParams,
    ChangeCredentialsResponse,
    CompleteProfileParam,
    Csrf,
    UsernameValidationResult,
    ValidityResponse
} from "./Account.types";


export const fetchUsernameValidation = (username: string, email: string): Promise<UsernameValidationResult> => {
    return new Promise<UsernameValidationResult>((resolve, reject) => {
        RestDataLoader.loadData(
            `support/registration?username=${username}&email=${email}`,
            {},
            resolve,
            reject,
            false
        )
    })
}

export const changeCredentialsRequest = (params: ChangeCredentialsParams): Promise<ChangeCredentialsResponse> => {
    return new Promise<ChangeCredentialsResponse>((resolve, reject) => {
        RestDataLoader.putJSON(
            "users/current/credentials",
            params,
            resolve,
            reject
        )
    })
}

export const completeProfileRequest = (param: CompleteProfileParam): Promise<VeboxModels.User> => {
    return new Promise<VeboxModels.User>((resolve, reject) => {
        RestDataLoader.patchJSON(
            "users/current",
            param,
            resolve,
            reject
        )
    })
}

export const getCurrentUser = (): Promise<VeboxModels.User> => {
    return new Promise<VeboxModels.User>((resolve, reject) => {
        RestDataLoader.loadData(
            `users/current`,
            {},
            (data) => {
                return resolve(data);
            },
            reject,
        );
    })
}

export function loginWithNewCredentials(username: string, password: string, token: Csrf): Promise<Response> {

    const form = new FormData()
    form.append(token.parameterName, token.token)
    form.append("username", username)
    form.append("password", password)

    return fetch(
        "/vebox/login",
        {
            method: "POST",
            body: form
        }
    )
}

export function getUsernameAndEmailValidity(username: string, email: string) {
    return new Promise<ValidityResponse>((res, rej) => {
        RestDataLoader.loadData(
            "support/registration?username=" + username + "&email=" + email,
            {},
            res,
            rej,
            false
        );
    });
}